export enum HideOn {
    mobile = "mobile",
    tablet = "tablet",
    desktop = "desktop",
}